import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "color", "title"];
import PropTypes from 'prop-types';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled from 'foundations-theming/utils';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrellisPreviewContainer = styled.div.withConfig({
  displayName: "EPPreviewWrapper__TrellisPreviewContainer",
  componentId: "l6z1ic-0"
})(["align-items:stretch;background-color:", ";border-width:", ";border-style:solid;display:flex;flex-grow:1;flex-shrink:1;flex-direction:column;justify-content:start;position:relative;", ""], ({
  theme
}) => theme.color['fill-surface-recessed'], ({
  theme
}) => theme.borderWidth['200'], ({
  $cssStyles
}) => $cssStyles);
const TrellisPreviewHeader = styled.div.withConfig({
  displayName: "EPPreviewWrapper__TrellisPreviewHeader",
  componentId: "l6z1ic-1"
})(["background-color:", ";color:", ";width:247px;height:29px;text-align:center;margin:0 auto;border-radius:0 0 12px 12px;position:relative;top:0;&::before{content:'';position:absolute;background:", ";top:0;left:-8px;bottom:0;width:25px;height:25px;transform:skew(45deg);}&::after{content:'';position:absolute;background:", ";top:0;right:-8px;bottom:0;width:25px;height:25px;transform:skew(135deg);}"], ({
  $color,
  theme
}) => theme.color[$color], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  $color,
  theme
}) => theme.color[$color], ({
  $color,
  theme
}) => theme.color[$color]);
const EPPreviewWrapper = props => {
  const {
      children,
      color,
      title
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(Object.assign({}, tokenProps, {
    borderColor: color
  }));
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(TrellisPreviewContainer, Object.assign({
      $cssStyles: cssStyles
    }, domProps, {
      children: [/*#__PURE__*/_jsx(TrellisPreviewHeader, {
        $color: color,
        children: title
      }), children]
    }))
  );
};
EPPreviewWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired
};
export const TrellisEPPreviewWrapper = EPPreviewWrapper;
export default EPPreviewWrapper;